import { Navigate, Outlet } from 'react-router'
import { useAuth } from '@/auth/useAuth'
import { PageNote } from '@/components/PageNote'

/** Route guard: unauthenticated visitors are sent to the login page. */
export function RequireAuth() {
  const { session, loading } = useAuth()

  if (loading) {
    return (
      <main className="flex min-h-svh items-center justify-center">
        <PageNote>Bezig met laden…</PageNote>
      </main>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
